import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/plazas-contribuciones-sobre-nomina';

/**
 * GET Contribuciones Sobre Nómina de las Plazas
 * @param {object} params { plaza, periodo_fiscal_en_curso: true } o { plaza, periodo_fiscal }
 * @returns {Promise<object[]>}
 */
export const getPlazasContribucionesSobreNomina = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
